import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import tag from '../../assets/images/tagimage_summary.png';
import qrcode from '../../assets/images/easytripportal.png';
import getPortalLocData from '../config/loc';



export class ConfirmationPage extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="limit-content main-container">
                {getPortalLocData().name === 'conventionCentre' &&
                    <div className="account-details col-12">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card text-center">
                                    <div className="card-header">
                                        <h2>You're all set!</h2> 
                                        <p className="card-text text-center">We have reserved a space for you at {this.props.locationDetail.selectedLocation.location.name} on {moment(this.props.locationDetail.bookingDetail.responseData.startDate).format('DD MMMM YYYY')} for your vehicle 
                                        {this.props.locationDetail.bookingDetail.responseData.vehicleRegistration}. You can arrive anytime between {moment(this.props.locationDetail.bookingDetail.responseData.startDate).format('hA')} and {moment(this.props.locationDetail.bookingDetail.responseData.endDate).format('hA')}. These details 
                                        along with your QR code have been email to you at {this.props.accountDetails.email}</p>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h5 className="card-title"><strong>Tag Access</strong></h5>
                                                        <img src={tag} alt=""/>
                                                        <p className="card-text">If you have an Easytrip tag,just rock up to the barrier and it will lift by reading your tag,no code needed!
                                                        please note the Easytrip tag will need to be assigned to the same registration number provided</p>

                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h5 className="card-title"><strong>QR Code Access: {this.props.locationDetail.bookingDetail.responseData.reference}</strong></h5>
                                                        <img src={getImage(this.props.locationDetail.bookingDetail.responseData.documents[0].rawData)} alt=""/>
                                                        <p className="card-text">If you don't have an Easytrip tag, you can use the QR emailed to you.Scan this QR code at the barrier and off you go! If you are using your phone to display the QR Code and are experiencing difficulty, please set the display brightness to maximum to facilitate a better read.</p>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="card-footer">
                                        <h5>You can log in to your Easytrip account at <a href="https://my.easytrip.ie">my.easytrip.ie</a> to view your booking, amend your booking or sign up for an Easytrip tag for easier access.</h5>
                                    </div>
                                </div>
                                
                            </div>

                        </div>
                    
                    </div>
                }


                {getPortalLocData().name === 'airport' &&
                    <div className=" col-12">
                        <div className="row">
                            <div className="col-md-12">
                                <div className=" text-center row justify-content-md-center">
                                    <div className="col-md-6 align-self-center">
                                        <h2>You're all set!</h2> 
                                        <p className="card-text text-center">We have reserved a space for you at {this.props.locationDetail.selectedLocation.location.name} on {moment(this.props.locationDetail.bookingDetail.responseData.startDate).format('DD MMMM YYYY')} for your vehicle {this.props.locationDetail.bookingDetail.responseData.vehicleRegistration}. You can arrive anytime between {moment(this.props.locationDetail.bookingDetail.responseData.startDate).format('hA')} and {moment(this.props.locationDetail.bookingDetail.responseData.endDate).format('hA')}. We have also emailed these details to  {this.props.accountDetails.email}</p>
                                        <p>You can enter the car park in two ways:</p>
                                    </div>
                                    <div className="">
                                        <div className="row my-4 position-relative">
                                            <div className="col-md-6">
                                                <div className="px-5">
                                                    <div className="">
                                                        <h5 className="">
                                                            <strong>Drive Up</strong>
                                                        </h5>
                                                        <img src={'images/airport/book-parking.png'} alt={'Parking'} />
                                                        <p className="">Simply drive to the barrier, we’ll recognise your car registration and let you in.</p>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="or or_Y">
                                                <span className="or_in">
                                                    or
                                                </span>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="px-5">
                                                    <div className="">
                                                        <h5 className="">
                                                            <strong>
                                                                QR Code Access: <span className="mono">{this.props.locationDetail.bookingDetail.responseData.reference}</span>
                                                            </strong>
                                                        </h5>
                                                        <img src={getImage(this.props.locationDetail.bookingDetail.responseData.documents[0].rawData)} alt=""/>
                                                        <p className="">Simply scan the QR code at the reader beside the barrier. If you are using your phone to display the QR Code, please set the display brightness to maximum to facilitate a better read.</p>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                }

            </div>

        );
    }

}
ConfirmationPage.propTypes={
    locationDetail:PropTypes.object,
    accountDetails:PropTypes.object
}

function getImage(base64Image) {
  return 'data:image/png;base64,' + base64Image;
}

function mapStateToProps(state) {
    return {
        locationDetail: state.locationDetail,
        accountDetails:state.accountDetails
    
    };
  }
  

  
  export default connect(
    mapStateToProps,
    null
  )(ConfirmationPage);





// WEBPACK FOOTER //
// ./src/containers/ConfirmationPage.jsx